import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OperationsService } from '../../../../core/services/operations.service';
import { SearchAnagraficheResponse } from '../../../models/dto/search-anagrafiche-response';

@Component({
    selector: '[searchTextInput]',
  templateUrl: 'search-text.component.html',
  styleUrls: ['search-text.component.css'],
  host: { '[class.row]': '\'true\'' }
})

export class SearchTextComponent implements OnInit {
  @Input() url: string;
  @Input() isAmministrazioneModule: boolean = false;
  @Output() onReturn: EventEmitter<SearchAnagraficheResponse> = new EventEmitter<SearchAnagraficheResponse>();
  lastCharacterInsertedTimeInMillis: number = -1;
  testoScritto: string;
  fromResult = 0;
  valueSearch: string;
  randomId: string = null;
  constructor(private operationsService: OperationsService) {}

  ngOnInit(): void {
      this.randomId = this.getRandomId();
  }

  onChange() {
    let newValue = this.testoScritto;
    this.valueSearch = newValue.trim();
    let now = new Date().getTime();
    this.lastCharacterInsertedTimeInMillis = now;
    let model: SearchTextComponent = this;
    setTimeout(function(){
      if (now === model.lastCharacterInsertedTimeInMillis) {
        model.manageValue();
      }
    }, 1000);
  }

  manageValue(isReloadSearch: boolean = false) {
    if (this.valueSearch && this.valueSearch.length < 3 ) {
      this.onReturn.emit(null);
    } else {
      if(this.valueSearch || isReloadSearch)
        this.operationsService.searchAnagrafiche(this.url, {searchText: (this.valueSearch ? this.valueSearch : '*'), fromResult: this.fromResult}).subscribe(response => this.emitList(response));
    }
    if(!this.valueSearch && this.isAmministrazioneModule && !isReloadSearch) {
      this.initSearch(this.url);
    }
  }

  initSearch(url) {
    this.fromResult=0;
    this.operationsService.searchAnagrafiche(url, {searchText: "*", fromResult: this.fromResult}).subscribe(response => this.emitList(response));
  }

  emitList(response: SearchAnagraficheResponse) {
    this.onReturn.emit(<SearchAnagraficheResponse> response);
  }

  setTextEmpty() {
    if (this.testoScritto) {
      this.testoScritto = '';
      this.valueSearch = '';
      this.manageValue();
    }
  }

  reset() {
    this.lastCharacterInsertedTimeInMillis = -1;
    this.testoScritto = null;
    this.fromResult = 0;
    this.valueSearch = null;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }
}
